"use client";

import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { ReactElement } from "react";
import { ContentfulImage } from "../../components/ContentfulImage";

import type { ContentLeadMember } from "../content";

type Props = {
  leadMembers: ContentLeadMember[];
};

export function PageComponent(props: Props): ReactElement {
  return (
    <>
      <Heading>Unsere Abteilungsleitung</Heading>
      <Flex
        flexWrap={["nowrap", "nowrap", "wrap"]}
        flexDirection={["column", "column", "row"]}
        mt={4}
      >
        {props.leadMembers.map((leadMember) => (
          <Box
            key={leadMember.id}
            borderWidth="1px"
            rounded="lg"
            boxShadow="md"
            overflow="hidden"
            mb={[8]}
            mx="auto"
          >
            <ContentfulImage
              src={leadMember.imageUrl}
              alt={leadMember.name}
              height={425}
              width={283}
            />
            <Box p={4}>
              <Heading as="h3" fontSize="lg" textAlign="center">
                {leadMember.name}
              </Heading>
              <Text textAlign="center">{leadMember.position}</Text>
            </Box>
          </Box>
        ))}
      </Flex>
    </>
  );
}
